import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';

// assets

// services

// props

// components
import { Stack } from '@fluentui/react';
import LoadingComponent from '../../../../feedbacks/loading';
import Timeline, { TimelineItemProps, TTimelineItemStatus } from '../../../../uiframeworks/timeline';
import moment from 'moment';
import { ICompanyApprovalResourceShortProps } from '../../../../../props/users/companies/approval';
import CompanyApprovalService from '../../../../../services/users/companies/approval';
import { ICompanyResourceShort } from '../../../../../props/users/company';
import CompanyStatus from '../../../../../manifests/status/company';

type CompanyDetailsApprovalsProps = {
    company: ICompanyResourceShort;
}

const CompanyDetailsApprovals: React.FC<CompanyDetailsApprovalsProps> = (props: CompanyDetailsApprovalsProps) => {
    const { banner, user } = useStore();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [histories, setHistories] = React.useState<ICompanyApprovalResourceShortProps[]>([]);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        setLoaded(false);

        const _histories = await CompanyApprovalService.retrieve(props.company.id, 'top=all');
        setHistories(_histories.data);
        setLoaded(true);
    }

    const getTimelineItems = () => {
        const items: TimelineItemProps[] = [];

        items.push({
            key: 'created',
            status: 'completed',
            date: moment(props.company.createdAt).format("DD/MM/YYYY HH:mm"),
            title: 'Company created by ' + props.company.createdBy.name,
            line: 'solid'
        });

        (histories.forEach((history) => {
            let status: TTimelineItemStatus = 'completed';
            let title: string = '';

            const type = CompanyStatus.find((s) => s.key === history.type);
            if (type?.key === 'pending_verification') {
                status = 'active';
                title = 'Verification status reset by ' + history.createdBy.name;
            } else if (type?.key === 'documents_rejected') {
                status = 'cancelled';
                title = 'Documents rejected by ' + history.createdBy.name;
            } else if (type?.key === 'documents_verified') {
                title = 'Documents approved by ' + history.createdBy.name;
                status = 'completed';
            } else if (type?.key === 'rejected') {
                status = 'cancelled';
                title = 'Rejected by ' + history.createdBy.name;
            } else if (type?.key === 'approved') {
                status = 'completed';
                title = 'Approved by ' + history.createdBy.name;
            }
            
            items.push({
                key: history.id,
                status: status,
                date: moment(history.createdAt).format("DD/MM/YYYY HH:mm"),
                description: (history.justification || "").trim() !== "" ? "Notes: " + history.justification : undefined,
                title: title,
                line: 'solid'
            });
        }));

        if (props.company.verificationStatus !== 'approved' && props.company.verificationStatus !== 'documents_rejected' && props.company.verificationStatus !== 'rejected') {
            items[items.length - 1].line = 'dashed';
            items.push({
                key: 'pendingApproval',
                status: 'infuture',
                title: 'Pending verification'
            });
        }

        return items;
    }

    return <Stack tokens={{ childrenGap: 20 }}>
        {!loaded ? <LoadingComponent label={'Retrieving approval histories ...'} labelPosition={'right'} spinnerPosition={'baseline'} /> : null}
        {loaded ? <Stack tokens={{childrenGap: 10}}>
            <Timeline items={getTimelineItems()} />
        </Stack> : null}
    </Stack>;
};

export default CompanyDetailsApprovals;